function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDostawaPunktOrlen = function SvgDostawaPunktOrlen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 956.693,
    height: 693.78
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "red"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1116.328-611.934c0-1.228-.364-2.45-1.01-3.533h-11.754c-.65 1.083-.94 2.305-.94 3.533 0 3.75 3.03 6.847 6.852 6.847 3.75 0 6.851-3.097 6.851-6.847M1109.476-599.604l-8.794-8.795c-4.546-4.473-10.458-7.068-16.803-7.068h-2.088c-7.789 0-14.131 6.345-14.131 14.205 0 3.098.932 5.48 2.451 8.073-.576-4.178 2.738-8.073 6.846-8.073h6.78c2.522 0 4.973 1.008 6.704 2.738l32.158 32.157c5.481-5.55 5.481-14.562 0-20.116l-13.123-13.121",
    style: {
      fill: "red",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(5.12346 0 0 5.12346 -5047.166 3273.758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1139.11-623.18-1.225-1.154c-4.902-4.905-11.465-7.715-18.386-7.715h-10.023l-8.794.072c-8.222 0-15.215 5.983-16.37 14.133h35.187c3.1 0 6.057 1.225 8.293 3.46l11.604 11.61c4.905 4.902 13.992 5.55 19.832-.29l-20.118-20.115M1018.485-540.987h-.216c-3.893.145-6.849 2.74-6.849 6.633 0 3.465 2.956 6.49 6.849 6.632h.216c3.534 0 6.634-3.1 6.634-6.632 0-3.965-3.1-6.633-6.634-6.633M1052.951-542.284c-.652-.288-1.372-.433-2.236-.433h-1.805v7.067h1.805c.864 0 1.584-.147 2.236-.434 1.15-.575 1.73-1.658 1.73-3.098 0-1.517-.58-2.597-1.73-3.102",
    style: {
      fill: "red",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(5.12346 0 0 5.12346 -5047.166 3273.758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.811-558.652H992.025v48.165h172.896v-48.165h-27.11zm-119.326 41.098h-.216c-9.59-.143-17.015-7.57-17.015-16.8 0-9.228 7.425-17.088 17.015-17.23h.216c9.302 0 16.798 8.002 16.798 17.23 0 9.3-7.495 16.8-16.798 16.8m35.762-.938-1.296-2.592-4.041-7.933v10.525h-10.092v-32.155h14.133c7.785.288 11.897 4.183 11.897 11.03 0 4.398-2.67 7.5-6.203 7.933l8.364 13.192h-12.762zm37.422 0h-21.558v-32.155h11.391v23.36h10.167v8.795zm27.395 0H1095.2v-32.155h22.496v7.93h-12.332v3.968h6.634v7.5h-6.634v3.962h13.699v8.795zm33.962 0h-9.736l-5.479-8.365-5.551-8.362c.503 1.732.503 3.535.503 4.832v11.895h-10.164v-32.155h9.661l5.551 8.363 5.479 8.365c0-2.165-.43-3.968-.43-5.263v-11.465h10.166v32.155",
    style: {
      fill: "red",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(5.12346 0 0 5.12346 -5047.166 3273.758)"
  })));
};
export default SvgDostawaPunktOrlen;